var Reverb = window.Reverb || {};
Reverb.Offers = Reverb.Offers || {};

Reverb.Offers.CollectLocation = (function () {
  function bindOfferSubmitLink() {
    $(document).on('ajax:complete', '[data-needs-location=\'true\']', function () {
      var lightboxUrl = $(this).data('needs-location-url');
      Reverb.UI.Ajax.lightbox(lightboxUrl);
    });
  }

  return {
    init: bindOfferSubmitLink
  };
})();

$(Reverb.Offers.CollectLocation.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/offers/collect_location.js